<template>
  <div class="app-main-content">
    <div class="main-content" style="overflow: auto;">
      <div v-show="!isPreview" :class="readonly ? 'not-click' : ''" style="width: fit-content">
        <div v-if="addedElements && addedElements.length > 0" class="section">
          <span class="title" style="width: 100%;">
            <span>{{ $t('SystemMaintenance.SystemAddedItem') }}</span>（{{ $t('SystemMaintenance.DragTheBlockUse') }}）
          </span>
          <div>
            <div v-for="element in addedElements" :ref="'added' + element.pagePartElement.elementName" :key="element.pagePartElement.elementName" style="width: fit-content;display: inline-block;line-height: 30px;margin: 0 15px;">
              <span style="vertical-align: middle;">{{ element.sysLabel }}</span>
              <span class="element-column-content sort-char" style="line-height: unset;" @mousedown="onAddedMousedown($event, element)">≡</span>
            </div>
          </div>
        </div>
        <div style="display: flex">
          <div v-for="block in upBlocks" :ref="block.pagePart.pagePartName" :key="block.pagePart.pagePartName" class="section" style="width: 371px;margin-right: 5px;">
            <el-form :disabled="readonly" label-width="140px" label-position="right" style="height: 100%;display: flex;flex-direction: column;">
              <span class="title" style="width: 100%;">
                {{ block.customLabel || block.sysLabel }}
                <i class="el-icon-edit" style="margin-left: 5px;" @click="onEditBlockLabel(block)" />
                <span class="sort-char" style="float: right;" @mousedown="onMousedown($event, block)">≡</span>
              </span>
              <el-form-item label=" ">
                <span class="element-column-text" :title="$t('SeaExport.Display')">{{ $t('SeaExport.Display') }}</span>
                <span class="element-column-text" :title="$t('SeaExport.Required')">{{ $t('SeaExport.Required') }}</span>
                <span class="element-column-text" :title="$t('SystemMaintenance.Alias')" style="width: 80px;">{{ $t('SystemMaintenance.Alias') }}</span>
                <span class="element-column-text" :title="$t('Tool.Setting')">{{ $t('Tool.Setting') }}</span>
                <span class="element-column-text" :title="$t('SystemMaintenance.Sort')">{{ $t('SystemMaintenance.Sort') }}</span>
              </el-form-item>
              <el-form-item v-for="element in block.uiCustomElementList" :ref="element.pagePartElement.elementName" :key="element.pagePartElement.elementName">
                <span slot="label" :class="element.isRequire ? 'blue' : ''">{{ element.sysLabel }}</span>
                <el-checkbox
                  v-model="element.isDisplay"
                  :disabled="!element.pagePartElement.displayCanCustom || (!!element.hqUICustomElement && element.hqUICustomElement.isRequire) || checkHqSetDisable(element)"
                  class="element-column-content"
                  @change="onDisplayChange(block, element)"
                />
                <el-checkbox
                  v-model="element.isRequire"
                  :disabled="!element.pagePartElement.requireCanCustom || (!!element.hqUICustomElement && element.hqUICustomElement.isRequire) || !element.isDisplay || checkHqSetDisable(element)"
                  class="element-column-content"
                />
                <span class="element-column-text" :title="element.customLabel" style="width: 80px;pointer-events: auto;">{{ element.customLabel }}</span>
                <span :class="'element-column-content' + (element.pagePartElement.aliasCanCustom && branchId === 1 && element.isDisplay ? '' : ' el-icon-edit-disabled')">
                  <i class="el-icon-edit" @click="onEditElementLabel(element)" />
                </span>
                <span class="element-column-content sort-char" style="line-height: unset;" @mousedown="onMousedown($event, block, element)">≡</span>
              </el-form-item>
            </el-form>
          </div>
        </div>
        <div v-if="downBlock" :ref="downBlock.pagePart.pagePartName" class="section" style="width: 371px">
          <el-form :disabled="readonly" label-width="140px" label-position="right">
            <span class="title" style="width: 100%;">
              {{ downBlock.customLabel || downBlock.sysLabel }}
            </span>
            <el-form-item label=" ">
              <span class="element-column-text" :title="$t('SeaExport.Display')">{{ $t('SeaExport.Display') }}</span>
              <span class="element-column-text" :title="$t('SeaExport.Required')">{{ $t('SeaExport.Required') }}</span>
              <span class="element-column-text" :title="$t('SystemMaintenance.Alias')" style="width: 80px;">{{ $t('SystemMaintenance.Alias') }}</span>
              <span class="element-column-text" :title="$t('Tool.Setting')">{{ $t('Tool.Setting') }}</span>
            </el-form-item>
            <el-form-item v-for="element in downBlock.uiCustomElementList" :ref="element.pagePartElement.elementName" :key="element.pagePartElement.elementName">
              <span slot="label" :class="element.isRequire ? 'blue' : ''">{{ element.sysLabel }}</span>
              <el-checkbox
                v-model="element.isDisplay"
                :disabled="!element.pagePartElement.displayCanCustom || (!!element.hqUICustomElement && element.hqUICustomElement.isRequire) || checkHqSetDisable(element)"
                class="element-column-content"
                @change="onDisplayChange(downBlock, element)"
              />
              <el-checkbox
                v-model="element.isRequire"
                :disabled="!element.pagePartElement.requireCanCustom || (!!element.hqUICustomElement && element.hqUICustomElement.isRequire) || !element.isDisplay || checkHqSetDisable(element)"
                class="element-column-content"
              />
              <span class="element-column-text" :title="element.customLabel" style="width: 80px;pointer-events: auto;">{{ element.customLabel }}</span>
              <span :class="'element-column-content' + (element.pagePartElement.aliasCanCustom && branchId === 1 && element.isDisplay ? '' : ' el-icon-edit-disabled')">
                <i class="el-icon-edit" @click="onEditElementLabel(element)" />
              </span>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <!-- 以下复制了一份页面内容，用于拖拽 -->
      <template>
        <div v-if="addedElements && addedElements.length > 0" class="section" style="height: 0;overflow: hidden;padding: 0;margin-bottom: 0;">
          <span class="title" style="width: 100%;">
            <span>{{ $t('SystemMaintenance.SystemAddedItem') }}</span>（{{ $t('SystemMaintenance.DragTheBlockUse') }}）
          </span>
          <div>
            <div v-for="element in addedElements" :ref="'addDrag' + element.pagePartElement.elementName" :key="element.pagePartElement.elementName" style="width: fit-content;display: inline-block;line-height: 30px;margin: 0 15px;">
              <span style="vertical-align: middle;">{{ element.sysLabel }}</span>
              <span class="element-column-content sort-char" style="line-height: unset;">≡</span>
            </div>
          </div>
        </div>
        <div v-for="block in blocks" :ref="'drag' + block.pagePart.pagePartName" :key="block.pagePart.pagePartName" class="section" style="width: 371px;height: 0;overflow: hidden;padding: 0;margin-bottom: 0;">
          <el-form label-width="140px" label-position="right">
            <span class="title" style="width: 100%;">
              {{ block.customLabel || block.sysLabel }}
              <i class="el-icon-edit" style="margin-left: 5px;" />
              <span class="sort-char" style="float: right;">≡</span>
            </span>
            <el-form-item label=" ">
              <span class="element-column-text" :title="$t('SeaExport.Display')">{{ $t('SeaExport.Display') }}</span>
              <span class="element-column-text" :title="$t('SeaExport.Required')">{{ $t('SeaExport.Required') }}</span>
              <span class="element-column-text" :title="$t('SystemMaintenance.Alias')" style="width: 80px;">{{ $t('SystemMaintenance.Alias') }}</span>
              <span class="element-column-text" :title="$t('Tool.Setting')">{{ $t('Tool.Setting') }}</span>
              <span class="element-column-text" :title="$t('SystemMaintenance.Sort')">{{ $t('SystemMaintenance.Sort') }}</span>
            </el-form-item>
            <el-form-item v-for="element in block.uiCustomElementList" :ref="'drag' + element.pagePartElement.elementName" :key="element.pagePartElement.elementName" style="background-color: #f0f3f8;">
              <span slot="label" :class="element.isRequire ? 'blue' : ''">{{ element.sysLabel }}</span>
              <el-checkbox v-model="element.isDisplay" class="element-column-content" />
              <el-checkbox v-model="element.isRequire" class="element-column-content" />
              <span class="element-column-text" :title="element.customLabel" style="width: 80px;">{{ element.customLabel }}</span>
              <span class="element-column-content"><i class="el-icon-edit" /></span>
              <span class="element-column-content sort-char" style="line-height: unset;">≡</span>
            </el-form-item>
          </el-form>
        </div>
      </template>
      <!-- 预览 -->
      <tab-hbl-UICustom v-if="isPreview" :context="bookingWorkspaceContext" action="look" :preview-config="previewConfig" />
    </div>
    <!-- 块设置弹窗 -->
    <block-set-dialog :visible.sync="blockSetDialog.visible" :block="blockSetDialog.block" />
    <!-- 元素设置弹窗 -->
    <element-set-dialog :visible.sync="elementSetDialog.visible" :element="elementSetDialog.element" />
  </div>
</template>

<script>
import tabHblUICustom from '@/views/cargo/v0/SeaExport/components/booking/tabs/tabHBLUICustom'
import rowTabScript from '@/views/cargo/v0/SystemMaintenance/components/pageUICustom/rowTabScript'
import { BookingWorkspaceContext } from '@/views/cargo/v0/SeaExport/components/booking/bookingWorkspaceContext'

export default {
  name: 'SeaBookingHbl',
  components: { tabHblUICustom, rowTabScript },
  mixins: [rowTabScript],
  data() {
    return {
      bookingWorkspaceContext: new BookingWorkspaceContext(),
      blockWidth: 371 // 包含主票：426，不包含：371
    }
  },
  computed: {
    downBlock() {
      return this.blocks.find(p => p.pagePartPosition === 2)
    }
  },
  created() {
    this.bookingWorkspaceContext.prepareData()
  }
}
</script>

<style lang="scss" scoped>
@import "./base.scss";
</style>
